import type { Object3D } from 'three';
import type { ExternalGeometrySourceDescriptor } from '../../model/ExternalGeometrySourceDescriptor';
import type {
	SketchEntityReferenceSelectionDisplayKind,
	SketchEntityReferenceSelectionIntentRecordKind,
	SketchEntityReferenceSelectionIntentRecordSnapshot,
} from '../../model/SketchEntityReferenceSelectionIntentRecordSnapshot';
import type {
	TopologyFaceReferenceSourceDescriptor,
} from '../../../../../types/reference/sketch-entity-reference/TopologyFaceReferenceSource';
import type {
	SketchEntityReferenceSelectionIntent,
	SketchEntityReferenceSelectionIntentSource,
} from '../../../../../types/reference/sketch-entity-reference/SketchEntityReferenceSelectionIntent';

export type {
	SketchEntityReferenceSelectionIntent,
	SketchEntityReferenceSelectionIntentSource,
} from '../../../../../types/reference/sketch-entity-reference/SketchEntityReferenceSelectionIntent';

/**
 * 创建可持久化的选择意图快照。
 *
 * @param input 选择意图与展开顺序。
 * @returns 可写入引用记录的纯数据快照。
 */
export function createSelectionIntentRecordSnapshot(input: {
	/** 用户选择意图。*/
	intent: SketchEntityReferenceSelectionIntent;
	/** 当前来源在展开集合中的序号。*/
	sourceIndex: number;
	/** 当前选择意图展开出的来源总数。*/
	sourceCount: number;
}): SketchEntityReferenceSelectionIntentRecordSnapshot {
	return {
		intentKind: input.intent.intentKind,
		intentId: input.intent.intentId,
		displayKind: input.intent.displayKind,
		displayLabel: input.intent.displayLabel,
		sourceIndex: input.sourceIndex,
		sourceCount: input.sourceCount,
		topologyFaceSource: input.intent.topologyFaceSource
			? structuredClone(input.intent.topologyFaceSource)
			: undefined,
		topologyFaceRegionSources: input.intent.topologyFaceRegionSources
			? structuredClone(input.intent.topologyFaceRegionSources)
			: undefined,
	};
}
